import Home from "../../Common/Home/Home";
import AddNewGuard from "./AddNewGuard";
// const base_url = process.env.REACT_APP_BASE_URL;
const AddNewGuardWrapper = () => {
  return (
    <>
      <Home propComponent={<AddNewGuard />} />
    </>
  );
};

export default AddNewGuardWrapper;
